import type { ReactNode } from 'react'
import { XIcon } from 'lucide-react'
import { cn } from '../../lib/utils'
import { DialogClose, DialogTitle } from './dialog'

export interface DialogHeaderProps {
	title:      ReactNode
	subtitle?:  ReactNode
	border?:    boolean
	className?: string
}

/**
 * Renders its own close button — pair with `<DialogContent showCloseButton={false}>`
 * to avoid two overlapping close buttons.
 */
function DialogHeader({ title, subtitle, border = false, className }: DialogHeaderProps) {
	return (
		<div
			className={cn(
				'flex items-start justify-between px-6 pt-6',
				subtitle ? 'pb-5' : 'pb-2',
				border && 'border-b border-(--color-border)',
				className,
			)}
		>
			<div className="flex flex-col gap-1">
				<DialogTitle className="text-xl font-[500] leading-7 tracking-[-0.4px] text-(--color-foreground)">
					{title}
				</DialogTitle>
				{subtitle && (
					<p className="text-sm text-(--color-muted-foreground)">{subtitle}</p>
				)}
			</div>
			<DialogClose
				render={
					<button
						type="button"
						className="rounded-(--radius-sm) p-0.5 text-(--color-muted-foreground) transition-colors hover:text-(--color-foreground)"
					/>
				}
			>
				<XIcon className="size-5" />
			</DialogClose>
		</div>
	)
}

export { DialogHeader }
